import { DrawerBody } from '@naturacosmeticos/natds-web';
import { styled } from '@material-ui/core/styles';

const StyledDrawerBody = styled(DrawerBody)({
  padding: ({ padding, p }) => padding || p,
});

export default StyledDrawerBody;
